import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/signature-maker")({
  component: SignatureMakerLayout,
});

function SignatureMakerLayout() {
  return <Outlet />;
}
